<template>
  <div class="form-version-container">
    <div id="pantalla-espera" v-if="isLoading"></div>
    <div v-show="state_pop_up_producto" id="producto-temporal" class="popup-container form layout">
      <div class="grid">
        <div class="container">
          <div class="row">
            <div v-if="productos.length" class="col-12" v-bind:class="{'filled': plantilla}">
              <label>Selecciona una plantilla</label>
              <multiselect 
              v-model="plantilla" 
              :options="productos" 
              :multiple="false" 
              :show-labels="false" 
              :close-on-select="true" 
              :hide-selected="false" 
              :preserve-search="false" 
              :searchable="true" 
              placeholder="Selecciona una plantilla de producto" 
              label="nombre" 
              track-by="id" 
              :allow-empty="true" 
              :preselect-first="false">
              <span slot="noResult">No se encontraron resultados.</span>
              </multiselect>
            </div>
            <div v-else class="col-12">
              <p>
                <a href="#" class="link" v-on:click.prevent="load_plantillas()"><i class="fas fa-sync-alt"></i> Cargar Plantillas</a>
              </p>
            </div>
            <div class="col-12" v-bind:class="{'filled': producto_temporal.id_servicio}">
              <label>Servicio</label>
              <multiselect 
              v-model="producto_temporal.id_servicio" 
              :options="servicios" 
              :multiple="false" 
              :show-labels="false" 
              :close-on-select="true" 
              :hide-selected="false" 
              :preserve-search="false" 
              :searchable="true" 
              placeholder="Selecciona un servicio" 
              label="nombre" 
              track-by="id" 
              :allow-empty="true" 
              :preselect-first="false">
              <span slot="noResult">No se encontraron resultados.</span>
              </multiselect>
            </div>
            <div class="col-12" v-bind:class="{'filled': producto_temporal.precio_base}">
              <label>Precio Base</label>
              <multiselect 
              v-model="producto_temporal.precio_base" 
              :options="producto_precio_base" 
              :multiple="false" 
              :show-labels="false" 
              :close-on-select="true" 
              :hide-selected="false" 
              :preserve-search="false" 
              :searchable="true" 
              placeholder="Selecciona un precio base (podrás modificarlo cuando generes la propuesta económica)" 
              label="nombre" 
              track-by="id" 
              :allow-empty="true" 
              :preselect-first="false">
              <span slot="noResult">No se encontraron resultados.</span>
              </multiselect>
            </div>
            <div class="col-12" v-bind:class="{'filled': producto_temporal.multiplicador != ''}">
              <label for="cantidad-base">Multiplicador</label>
              <input id="cantidad-base" type="number" v-model="producto_temporal.multiplicador" placeholder="Escribe algo...">
            </div>
            <div class="col-12" v-bind:class="{'filled': producto_temporal.nombre != ''}">
              <label for="nombre">Nombre</label>
              <input id="nombre" type="text" v-model="producto_temporal.nombre" placeholder="Escribe algo...">
            </div>
            <div class="col-12" v-bind:class="{'filled': producto_temporal.contenido != ''}">
              <label for="contenido">Contenido</label>
              <ckeditor :editor="editor" v-model="producto_temporal.contenido" :config="editorConfigContent"></ckeditor>
            </div>
            <div class="col-12" v-bind:class="{'filled': producto_temporal.anotaciones != ''}">
              <label for="anotaciones">Anotaciones</label>
              <ckeditor :editor="editor" v-model="producto_temporal.anotaciones" :config="editorConfigText"></ckeditor>
            </div>
            <!--MENSAJES-->
            <div class="col-12">
              <ul v-if="messages_temporal.length" class="messages-container">
                <li v-for="message in messages_temporal" :key="message.content" v-bind:class="['message-item t-12-px', message.type]"><i class="fas fa-times" @click.prevent.stop="delete_message(message, messages_temporal)"></i> {{message.content}}</li>
              </ul>
            </div>
            <div class="col">
              <button v-on:click.prevent="close_producto_temporal()" class="btn b-warn">Cancelar</button>
            </div>
            <div class="col t-right">
              <button v-on:click.prevent="assign_producto_temporal()" class="btn b-secondary">Listo</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="state_pop_up_preview" id="preview-container" class="popup-container layout">
      <div class="grid">
        <div class="container">
          <div class="row">
            <div class="col-12" style="max-height: calc(100vh - 200px); overflow: auto;">
              <div id="preview_columnas" class="preview_contenedor temporal visible"></div>
              <div class="preview_contenedor quote_page">
                <div v-for="(producto, index) in prop_version.contenido" v-bind:key="index" class="quote_page_content">
               	  <h1 v-if="index == 0">Servicios</h1>
                  <div v-if="!producto.salto || producto.salto != true" class="quote_page_product" v-html="'<h2>'+producto.nombre+'</h2>'+producto.contenido+producto.anotaciones"></div>
                  <div v-else class="quote_page_product" v-html="'<span class=columnbreak></span>'"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form v-on:submit.prevent="actionForm('form')" class="form layout">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <label for="color">Selecciona un Color</label>
            <swatches v-model="prop_version.color" :colors="colors" row-length="20" popover-to="right" swatch-size="20"></swatches>
          </div>
          <div class="col-4 phone-c-12" v-bind:class="{'filled': prop_version.fecha != ''}">
            <label for="fecha">Fecha Cotización</label>
            <datetime v-model="prop_version.fecha" type="datetime" use12-hour id="date_input"></datetime>
          </div>
          <div class="col-8 phone-c-12" v-bind:class="{'filled': prop_version.nombre != ''}">
            <label for="nombre">Desglose de Servicios</label>
            <input id="nombre" type="text" v-model="prop_version.nombre" placeholder="Escribe algo...">
          </div>
          <div class="col-12" v-bind:class="{'filled': prop_version.id_cliente}">
            <label>[Cliente] — Contacto — Saludo</label>
            <multiselect 
            v-model="prop_version.id_cliente" 
            :options="clientes" 
            :multiple="false" 
            :show-labels="false" 
            :close-on-select="true" 
            :hide-selected="false" 
            :preserve-search="false" 
            :searchable="true" 
            placeholder="Selecciona un cliente" 
            track-by="id" 
            :custom-label="cliente_datos_label" 
            label="nombre" 
            :allow-empty="true" 
            :preselect-first="false">
            <span slot="noResult">No se encontraron resultados.</span>
            </multiselect>
          </div>
          <!--CONTENIDO-->
          <div class="col-12" v-if="prop_version.contenido">
            <div class="row">
              <div class="col">
                <p class="t-16-px t-complementary"><strong>Contenido</strong></p>
              </div>
              <div class="col-auto">
                <p v-if="!prop_version.contenido || !prop_version.contenido.length" class="t-right">
                  <a href="#" class="t-14-px link t-secondary" v-on:click.prevent="$set(prop_version, 'contenido', []); prop_version.contenido = [{id_servicio: [], multiplicador: '1', nombre: 'Nuevo Producto', contenido: '', anotaciones: ''}]">Crear Contenido</a>
                </p>
              </div>
              <div v-if="prop_version.contenido && prop_version.contenido.length" class="col-12 box-container b-white moves-container no-select">
                <draggable class="list-container container" v-model="prop_version.contenido" handle=".handle-products">
                  <li v-for="(producto, index) in prop_version.contenido" v-bind:key="index" class="row v-items-center">
                    <div class="col-auto handle-container handle-products">
                      <div class="handle">
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                    <div v-if="!producto.salto || producto.salto != true" class="col" v-on:click.prevent="isLoading = true; changeElement(producto, index)">
                      <div class="container">
                        <div class="row v-items-center">
                          <div class="col-auto">
                            <span class="icon-list" v-bind:style="{'background-color': producto.id_servicio.color}">
                              <b class="t-16-px">{{producto.id_servicio.abreviacion}}</b>
                            </span>
                          </div>
                          <div class="col">
                            <p class="t-complementary t-14-px">
                              <span>{{producto.nombre | cutText}}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="col">
                      <div class="container">
                        <div class="row v-items-center">
                          <div class="col">
                            <p class="t-complementary t-14-px t-center">
                              <span>{{producto.nombre}}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-auto">
                      <a href="#" class="t-complementary" v-on:click.prevent="deleteElement(prop_version.contenido, index)">
                        <i class="fa fa-trash"></i>
                      </a>
                    </div>
                   </li>
                </draggable>
              </div>
              <div v-if="prop_version.contenido && prop_version.contenido.length" class="col">
                <p class="t-center">
                  <a href="#" class="t-14-px link t-secondary" v-on:click.prevent="prop_version.contenido.push({id_servicio: [], multiplicador: '1', nombre: 'Nuevo Producto', contenido: '', anotaciones: ''})">Agregar Elemento</a>
                </p>
              </div>
              <div v-if="prop_version.contenido && prop_version.contenido.length" class="col">
                <p class="t-center">
                  <a href="#" class="t-14-px link t-secondary" v-on:click.prevent="prop_version.contenido.push({id_servicio: [], multiplicador: '1', nombre: 'Salto Página', contenido: '', anotaciones: '', salto: true})">Agregar Salto Página</a>
                </p>
              </div>
            </div>
          </div>
          <!--PROPUESTA ECONOMICA-->
          <div class="col-12" v-if="prop_version.propuesta_inversion">
            <div class="row quote-row-draggable">
              <div class="col">
                <p class="t-16-px t-complementary"><strong>Propuesta Económica</strong></p>
              </div>
              <div class="col-auto">
                <p v-if="!prop_version.propuesta_inversion.elementos || !prop_version.propuesta_inversion.elementos.length" class="t-right">
                  <a href="#" class="t-14-px link t-secondary" v-on:click.prevent="crear_propuesta_inversion_elementos()">Crear Propuesta</a>
                </p>
                <p v-else class="t-right">
                  <a href="#" class="t-14-px link t-secondary" v-on:click.prevent="crear_propuesta_inversion_elementos()">Actualizar Propuesta</a>
                </p>
              </div>
            </div>
            <div v-if="prop_version.propuesta_inversion.elementos && prop_version.propuesta_inversion.elementos.length" class="row">
              <div class="col-12 box-container b-white moves-container no-select">
                <draggable class="list-container container" v-model="prop_version.propuesta_inversion.elementos" group="lista_propuesta_inversion" handle=".handle-propuesta-economica">
                  <li v-for="(propuesta_inversion_elemento, index) in prop_version.propuesta_inversion.elementos" :key="index" class="row v-items-center">
                    <div class="col-auto handle-container handle-propuesta-economica">
                      <div class="handle">
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                    <div class="col">
                      <div class="container">
                        <div class="row">
                          <div class="col phone-c-12" v-bind:class="{'filled': propuesta_inversion_elemento.nombre != ''}">
                            <label>Nombre</label>
                            <textarea v-model="propuesta_inversion_elemento.nombre" rows="1" placeholder="Escribe algo..." style="min-height: 40px;"></textarea>
                          </div>
                          <div class="col-2 phone-c-12" v-bind:class="{'filled': propuesta_inversion_elemento.frecuencia != ''}">
                            <label>Frecuencia</label>
                            <multiselect 
                            v-model="propuesta_inversion_elemento.frecuencia" 
                            :options="tipos_frecuencia" 
                            :multiple="false" 
                            :show-labels="false" 
                            :close-on-select="true" 
                            :hide-selected="false" 
                            :preserve-search="false" 
                            :searchable="true" 
                            placeholder="Selecciona un tipo de frecuencia" 
                            label="" 
                            track-by="" 
                            :allow-empty="false" 
                            :preselect-first="true">
                            <span slot="noResult">No se encontraron resultados.</span>
                            </multiselect>
                          </div>
                          <div class="col-2 phone-c-12" v-bind:class="{'filled': propuesta_inversion_elemento.cantidad != ''}">
                            <label>Cantidad</label>
                            <input type="text" v-model="propuesta_inversion_elemento.cantidad" placeholder="Escribe algo..." v-on:focus="$event.target.select()">
                          </div>
                          <div class="col-2 phone-c-12" v-bind:class="{'filled': propuesta_inversion_elemento.precio != ''}">
                            <label>Precio Unitario</label>
                            <input type="text" v-model="propuesta_inversion_elemento.precio" placeholder="Escribe algo..." v-on:focus="$event.target.select()">
                          </div>
                          <div class="col-2 phone-c-12" v-bind:class="{'filled': propuesta_inversion_elemento.precio_hora != ''}">
                            <label>Precio x Hora</label>
                            <input type="text" v-model="propuesta_inversion_elemento.precio_hora" placeholder="Escribe algo..." v-on:focus="$event.target.select()">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-auto">
                      <a href="#" class="t-complementary" v-on:click.prevent="deleteElement(prop_version.propuesta_inversion.elementos, index)">
                        <i class="fa fa-trash"></i>
                      </a>
                    </div>
                   </li>
                </draggable>
              </div>
            </div>
            <div v-if="prop_version.propuesta_inversion.elementos && prop_version.propuesta_inversion.elementos.length" class="col-12">
              <div class="row v-items-center container-selector-salto-propuesta">
              	<div class="col-auto">
              		<label class="switch-toggle">
              		  <input type="checkbox" v-model="prop_version.propuesta_inversion.salto">
              		  <span></span>
              		</label>
              	</div>
              	<div class="col">
              		<p>Agregar salto de línea después de propuesta económica</p>
              	</div>
              	<div class="col-auto">
              	  <p class="t-center">
              	    <a href="#" class="t-14-px link t-secondary" v-on:click.prevent="prop_version.propuesta_inversion.elementos.push({nombre: '', frecuencia: 'Unitario', precio: '', cantidad: 1,})">Agregar Elemento</a>
              	  </p>
              	</div>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="prop_version.propuesta_inversion && prop_version.propuesta_inversion.elementos">
          	<div class="row quote-row-draggable"></div>
            <div class="row">
              <div class="col-12 box-container b-white moves-container no-select">
                <div class="row">
                  <div class="col phone-c-12" v-bind:class="{'filled': prop_version.propuesta_inversion.pagos != ''}">
                    <label>Cantidad de Pagos</label>
                    <input type="text" v-model="prop_version.propuesta_inversion.pagos" placeholder="Escribe algo...">
                  </div>
                  <div class="col phone-c-12" v-bind:class="{'filled': prop_version.propuesta_inversion.descuento != ''}">
                    <label>Porcentaje de Descuento</label>
                    <input type="text" v-model="prop_version.propuesta_inversion.descuento" placeholder="Escribe algo...">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12" v-bind:class="{'filled': prop_version.propuesta_inversion.nota != ''}">
                    <label for="anotaciones">Propuesta de Inversión</label>
                    <input type="text" v-model="prop_version.propuesta_inversion.titulo" placeholder="Escribe algo..." v-on:focus="$event.target.select()">
                  </div>
                  <div class="col-12" v-bind:class="{'filled': prop_version.propuesta_inversion.nota != ''}">
                    <label for="anotaciones">Anotaciones Propuesta de Inversión</label>
                    <ckeditor :editor="editor" v-model="prop_version.propuesta_inversion.nota" :config="editorConfigBold"></ckeditor>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <p class="t-18-px t-complementary t-center"><strong>Inversión</strong>: <span v-html="prop_version.propuesta_inversion.valor"></span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--MENSAJES-->
          <div class="col-12">
            <ul v-if="messages.length" class="messages-container">
              <li v-for="message in messages" :key="message.content" v-bind:class="['message-item t-12-px', message.type]"><i class="fas fa-times" @click.prevent.stop="delete_message(message, messages)"></i> {{message.content}}</li>
            </ul>
          </div>
          <div class="col-12">
            <button v-if="this.$route.params.version" type="submit" class="btn b-primary">Guardar Cambios</button>
            <button v-if="this.$route.params.version" v-on:click.prevent="actionForm('clone-version')" class="btn b-secondary">Clonar Versión</button>
            <button v-if="this.$route.params.version" v-on:click.prevent="actionForm('clone-quote')" class="btn b-white">Clonar Cotización</button>
            <button v-if="!this.$route.params.id" v-on:click.prevent="actionForm('form')" class="btn b-white">Crear Cotización</button>
            <button v-if="this.$route.params.id && !this.$route.params.version" v-on:click.prevent="actionForm('add-version')" class="btn b-secondary">Crear Versión</button>
          </div>
        </div>
      </div>
    </form>
    <div v-if="!state_pop_up_producto" class="short-menu-container layout" style="z-index: 9999;">
      <div v-if="prop_version.contenido && prop_version.contenido.length" class="grid">
          <div class="short-actions no-select">
            <div class="btn-short-actions b-secondary" v-on:click.prevent="get_preview()"><i v-if="!state_pop_up_preview" class="far fa-eye"></i><i v-else class="fas fa-times"></i></div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swatches from 'vue-swatches'
import Multiselect from 'vue-multiselect'
import draggable from 'vuedraggable'
import { Datetime } from 'vue-datetime'
import router from '@/router'
import { getColors } from '@/colors.js'
import { db, auth } from '@/firebase'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import '@ckeditor/ckeditor5-build-classic/build/translations/es'
export default {
  name: 'formVersion',
  components: {
    draggable,
    Multiselect,
    datetime: Datetime,
    Swatches
  },
  props: {
    prop_cotizacion: {
      required: false,
      type: Object,
      default(){
        return {}
      }
    },
    prop_version: {
      required: false,
      type: Object,
      default(){
        return {
          'color': '#fff',
          'contenido': [], 
          'fecha': new Date().toISOString(), 
          'id_cliente': '', 
          'nombre': '', 
          'propuesta_inversion': {
            'elementos': [],
            'salto': false,
            'valor': '',
            'pagos': '1',
            'descuento': '0',
            'titulo': '',
            'nota': '',
            'tipo': ''
          },
        }
      }
    },
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfigContent: {
        fontSize: {
          options: [
            'default',
            10,
            12,
            14,
            16,
            18,
            21,
            24
          ]
        },
        toolbar: {
          items: [
            //'heading',
            'fontSize', 
            '|',
            'bold',
            //'italic',
            //'link',
            'bulletedList',
            //'numberedList',
            //'imageUpload',
            //'blockQuote',
            'undo',
            'redo'
          ]
        },
        language: 'es'
      },
      editorConfigText: {
        fontSize: {
          options: [
          	'default',
            10,
            12,
            14,
            16,
            18,
            21,
            24
          ]
        },
        toolbar: {
          items: [
            //'heading',
            'fontSize', 
            '|',
            'bold',
            //'italic',
            //'link',
            //'bulletedList',
            //'numberedList',
            //'imageUpload',
            //'blockQuote',
            'undo',
            'redo'
          ]
        },
        language: 'es'
      },
      editorConfigBold: {
        toolbar: {
          items: [
            //'heading',
            //'fontSize', 
            //'|',
            'bold',
            //'italic',
            //'link',
            //'bulletedList',
            //'numberedList',
            //'imageUpload',
            //'blockQuote',
            'undo',
            'redo'
          ]
        },
        language: 'es'
      },
      state_pop_up_preview: false,
      isLoading: false,
      producto_temporal: [{id_servicio: [], precio_base: [], multiplicador: '', nombre: '', contenido: '', anotaciones: ''}],
      state_pop_up_producto: false,
      tipos_frecuencia: ['Unitario', 'Mensual', 'Bimestral', 'Trimestral', 'Cuatrimestral', 'Semestral'],
      valor_total_cotizaciones: [{'valor': 1}],
      servicios: [],
      producto_precio_base: [],
      clientes: [],
      productos: [],
      plantilla: [],
      usuario_login: [],
      messages: [],
      messages_temporal: [],
      colors: getColors,
    }
  },
  firestore () {
    return {
      usuario_login: db.collection('usuarios').doc(auth.currentUser.uid),
      valor_total_cotizaciones: db.collection('valores').where('relacion', '==', 'total_cotizaciones').limit(1),
      servicios: db.collection('servicios').orderBy('orden', 'asc'), 
      clientes: db.collection('clientes').orderBy('nombre', 'asc'),
      //productos: db.collection('productos').orderBy('fecha_modificacion', 'desc'),
    }
  },
  watch: {
    plantilla: {
      deep: true,
      handler(newArray, oldArray){
        let vm = this
        if(!oldArray.id){
          const answer = window.confirm('¿Estás Seguro? Esto modificará la información actual')
          if(answer){
            vm.isLoading = true
            vm.producto_temporal.id_servicio = vm.plantilla.id_servicio
            vm.producto_temporal.multiplicador = vm.plantilla.multiplicador
            vm.producto_temporal.nombre = vm.plantilla.nombre
            vm.producto_temporal.contenido = vm.plantilla.contenido
            vm.producto_temporal.anotaciones = vm.plantilla.anotaciones  
            vm.producto_temporal.precio_1 = vm.plantilla.precio_1  
            vm.producto_temporal.precio_2 = vm.plantilla.precio_2  
            vm.producto_temporal.precio_3 = vm.plantilla.precio_3  
            setTimeout(function () {
              vm.isLoading = false
            }, 2500)
            vm.plantilla = []
          }else{
            vm.plantilla = []
          }
        }
      }
    },
    producto_temporal: {
      deep: true,
      handler(newArray, oldArray){
        let vm = this

        //--Precio base
        
        let array_precios_base = [];

        if(vm.producto_temporal.precio_1){
        	array_precios_base.push({
        		id: 1,
        		nombre: 'Precio 1' + ' - ' + vm.producto_temporal.precio_1,
        		precio: vm.producto_temporal.precio_1
        	});
        }
        if(vm.producto_temporal.precio_2){
        	array_precios_base.push({
        		id: 2,
        		nombre: 'Precio 2' + ' - ' + vm.producto_temporal.precio_2,
        		precio: vm.producto_temporal.precio_2
        	});
        }
        if(vm.producto_temporal.precio_3){
        	array_precios_base.push({
        		id: 3,
        		nombre: 'Precio 3' + ' - ' + vm.producto_temporal.precio_3,
        		precio: vm.producto_temporal.precio_3
        	});
        }

        vm.producto_precio_base = array_precios_base

        //--Precio base

        setTimeout(function () {
          vm.isLoading = false
        }, 2500)
      }
    },
    prop_version: {
      deep: true,
      handler(newArray, oldArray){
        if(oldArray){
          if(!this.isLoading){
            this.$emit('actionChange', true)
          }
        }else{
          this.$emit('actionChange', false)
        }
        if(newArray.fecha){
          if(newArray.fecha.seconds > 0){
            let vm = this
            //Cambiar formato de la fecha
            const value = newArray.fecha.seconds
            const curdate = new Date(null)
            const date = curdate.setTime(value*1000)
            const momentdate = curdate.toISOString()
            vm.prop_version.fecha = momentdate
          }
        }
        if(newArray.propuesta_inversion){
          let vm = this
          if(vm.prop_version.propuesta_inversion.pagos){
            vm.prop_version.propuesta_inversion.pagos = vm.$options.filters.formatEntero(vm.prop_version.propuesta_inversion.pagos)
          }
          if(vm.prop_version.propuesta_inversion.descuento){
            vm.prop_version.propuesta_inversion.descuento = vm.$options.filters.formatDecimal(vm.prop_version.propuesta_inversion.descuento)
          }
          if(vm.prop_version.propuesta_inversion.elementos){
          	var total_cotizacion = 0

          	for(var prop_inversion in this.prop_version.propuesta_inversion.elementos){
          	  //Cambiar formato solo al precio y cantidad
          	  if(vm.prop_version.propuesta_inversion.elementos.hasOwnProperty(prop_inversion)){
          	    if(vm.prop_version.propuesta_inversion.elementos[prop_inversion].precio){
          	      vm.prop_version.propuesta_inversion.elementos[prop_inversion].precio = vm.$options.filters.formatNumber(vm.prop_version.propuesta_inversion.elementos[prop_inversion].precio)
                  vm.prop_version.propuesta_inversion.elementos[prop_inversion].precio_hora = vm.$options.filters.formatNumber(vm.prop_version.propuesta_inversion.elementos[prop_inversion].precio_hora)
          	    }
          	    if(vm.prop_version.propuesta_inversion.elementos[prop_inversion].cantidad){
          	      vm.prop_version.propuesta_inversion.elementos[prop_inversion].cantidad = vm.$options.filters.formatEntero(vm.prop_version.propuesta_inversion.elementos[prop_inversion].cantidad)
          	    }
          	  }
          	  //Sumar al total de inversion
          	  if(vm.$options.filters.formatDecimal(vm.prop_version.propuesta_inversion.elementos[prop_inversion].precio) > 0 && vm.prop_version.propuesta_inversion.elementos[prop_inversion].cantidad > 0){
          	    total_cotizacion += vm.$options.filters.formatDecimal(vm.prop_version.propuesta_inversion.elementos[prop_inversion].precio) * vm.prop_version.propuesta_inversion.elementos[prop_inversion].cantidad
          	  }
          	}

          	var resultado_propuesta_inversion = ' ' + vm.$options.filters.formatPrice(total_cotizacion)

          	var numero_pagos = vm.prop_version.propuesta_inversion.pagos

          	var porcentaje_descuento = vm.prop_version.propuesta_inversion.descuento

          	var precio_pago = total_cotizacion / numero_pagos

          	var precio_descuento = precio_pago - (precio_pago * (porcentaje_descuento / 100))

          	if(numero_pagos > 0){

          		if(porcentaje_descuento > 0 && porcentaje_descuento < 100){
          			resultado_propuesta_inversion += ' en ' + numero_pagos + ' pago(s) de ' + ' <del class="t-base">' + vm.$options.filters.formatPrice(precio_pago) + '</del> ' + vm.$options.filters.formatPrice(precio_descuento) 
          		}else{
          			resultado_propuesta_inversion += ' en ' + numero_pagos + ' pago(s) de ' + vm.$options.filters.formatPrice(precio_pago)
          		}

          	}

          	vm.prop_version.propuesta_inversion.valor = resultado_propuesta_inversion
          }
        }
      }
    },
  },
  methods: {
  	cliente_datos_label ({ empresa, contacto, nombre }) {
  		var the_client = ''
  		if(empresa){
  			the_client += '[' + empresa + '] — '
  		}
  		if(contacto){
  			the_client += contacto + ' — '
  		}
  		if(nombre){
  			the_client += nombre
  		}
  	    return the_client
  	},
  	crear_propuesta_inversion_elementos (){
  		var vm = this

  		vm.$set(vm.prop_version.propuesta_inversion, 'elementos', [])

  		if(vm.prop_version.contenido.length){
  			for(var turno_producto = 0; turno_producto < vm.prop_version.contenido.length; turno_producto++){
  				if(!vm.prop_version.contenido[turno_producto].salto || vm.prop_version.contenido[turno_producto].salto != true){
  					var precio_base_item = 0
  					if(vm.prop_version.contenido[turno_producto].precio_base != null){

              var multiplicador_item = 1

              if(vm.prop_version.contenido[turno_producto].multiplicador != null){

                multiplicador_item = Number(vm.prop_version.contenido[turno_producto].multiplicador)

              }

  						precio_base_item = vm.$options.filters.formatNumber(vm.$options.filters.formatDecimal(vm.prop_version.contenido[turno_producto].precio_base.precio) * multiplicador_item)

  					}
  					vm.prop_version.propuesta_inversion.elementos.push({nombre: vm.prop_version.contenido[turno_producto].nombre, frecuencia: 'Unitario', precio: precio_base_item, cantidad: 1,})
  				}
  			}
  		}else{
  			vm.prop_version.propuesta_inversion.elementos.push({nombre: '', frecuencia: 'Unitario', precio: '', cantidad: 1,})
  		}
  	}, 
    deleteElement (value, index){
      value.splice(index, 1)
    },
    load_plantillas (){

      var vm = this

      vm.isLoading = true

      vm.productos = []

      let plantillas = db.collection('productos').orderBy('fecha_modificacion', 'desc')

      plantillas.get().then(async documentSnapshots => {
        documentSnapshots.forEach(doc => {
          const documento_producto = doc.data()
          documento_producto.id = doc.id
          //Comprobar y asignar referencias
          if(documento_producto.id_servicio){
            if(documento_producto.id_servicio){
              documento_producto.id_servicio.get().then(snap => {
                documento_producto.id_servicio = snap.data()
                documento_producto.id_servicio.id = snap.id
              })
            }
            vm.productos.push(documento_producto)
          }else{
            vm.productos.push(documento_producto)
          }
        })
        vm.isLoading = false
      })
      .catch(function(error) {
        //Error al cargar plantillas
        vm.isLoading = false
        vm.messages.push({type: 'fatal b-fail', content: error.message})
      })
    },
    get_preview (){
      var vm = this
      if(!vm.state_pop_up_preview){
        vm.state_pop_up_preview = true
        vm.isLoading = true
        if($('.quote_page').html() != ''){
          $('#preview_columnas').html($('.quote_page').html())
          setTimeout(function () {
            //Solucion columnas con altura cercana
            var ancho_columna_temporal = 612 - 40 - 40 //Ancho pagina menos margenes horizontales
            var alto_columna_temporal = 792 - 125 - 60 //alto pagina menos margenes verticales
            $('#preview_columnas').css({'width': ancho_columna_temporal + 'px'}) //Asignar ancho de una columna
            var altura_test = $('#preview_columnas').outerHeight(true) //Obtener el alto del elemento con el nuevo ancho
            var total_cols = Math.ceil(altura_test / alto_columna_temporal) //Obtener el total de columnas dividiendo la altura entre el alto de la columna
            $('#preview_columnas').css({'width': (ancho_columna_temporal * total_cols) + 'px'}) //Asignarle el nuevo ancho en base al total de las columnas
            $('#preview_columnas').columnize({
              height : alto_columna_temporal, 
              width: ancho_columna_temporal,
              lastNeverTallest: true, 
              buildOnce: true,
              doneFunc : function(){
                $('<span class="separador-hojas"></span>').insertAfter('#preview_columnas .column:not(.last)')
                $('#preview_columnas').css({'width': ancho_columna_temporal + 'px', 'margin': '0 auto'})
                $('#preview_columnas .column').css({'width': ancho_columna_temporal + 'px'})
                vm.isLoading = false
              }
            })
          }, 600)
        }
      }else{
        vm.state_pop_up_preview = false
        vm.isLoading = false
      }
    },
    changeElement (value, index){
      if(value){
        this.messages_temporal = []
        this.producto_temporal = {id_servicio: value.id_servicio, precio_base: value.precio_base, multiplicador: value.multiplicador, nombre: value.nombre, contenido: value.contenido, anotaciones: value.anotaciones, precio_1: value.precio_1, precio_2: value.precio_2, precio_3: value.precio_3}
        this.$set(this.producto_temporal, 'index', index)
        this.state_pop_up_producto = true
      }
    },
    close_producto_temporal (){
      //const answer = window.confirm('¿Estás Seguro? Se perderá la información que se haya modificado')
      //if(answer){
      //  this.state_pop_up_producto = false
      //  this.producto_temporal = [{id_servicio: [], precio_base: [], multiplicador: '', nombre: '', contenido: '', anotaciones: ''}]
      //} else {
      //  //
      //}
      this.state_pop_up_producto = false
      this.producto_temporal = [{id_servicio: [], precio_base: [], multiplicador: '', nombre: '', contenido: '', anotaciones: ''}]
    },
    assign_producto_temporal (){
      //Validar que tenga servicio y nombre asignado
      this.messages_temporal = []
      if(!this.producto_temporal.id_servicio) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario asignar un servicio'
        }
        this.messages_temporal.push(the_message)
      }
      if(!this.producto_temporal.nombre) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario ingresar un nombre'
        }
        this.messages_temporal.push(the_message)
      }
      if(!this.messages_temporal.length){
        const answer = window.confirm('¿Estás Seguro? Esto modificará la información actual')
        if(answer){
          this.state_pop_up_producto = false
          this.prop_version.contenido[this.producto_temporal.index] = this.producto_temporal
          this.producto_temporal = [{id_servicio: [], precio_base: [], multiplicador: '', nombre: '', contenido: '', anotaciones: ''}]
        } else {
          //
        }
      }      
    },
    delete_message (value, arreglo){
     this.messages.splice(arreglo.indexOf(value), 1)
    },
    actionForm (type) {
      var item_creacion = new Date()
      var url = 'dashboard'
      this.messages = []

      if(!this.prop_version.color) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario seleccionar un color'
        }
        this.messages.push(the_message)
      }

      if(!this.prop_version.nombre) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario ingresar un desglose de servicios'
        }
        this.messages.push(the_message)
      }

      if(!this.prop_version.id_cliente) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario seleccionar un cliente'
        }
        this.messages.push(the_message)
      }

      if(!this.prop_version.contenido || !this.prop_version.contenido.length) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario ingresar por lo menos un producto al contenido'
        }
        this.messages.push(the_message)
      }else{
        for(var turn_producto_contenido = 0; turn_producto_contenido < this.prop_version.contenido.length; turn_producto_contenido++){
          //Revisar que no sea un salto
          if(!this.prop_version.contenido[turn_producto_contenido].salto || this.prop_version.contenido[turn_producto_contenido].salto != true){
            if(!this.prop_version.contenido[turn_producto_contenido].id_servicio || this.prop_version.contenido[turn_producto_contenido].id_servicio == ''){
              const the_message = {
                type: 'fatal b-fail',
                content: 'Es necesario ingresar un servicio al producto '+(turn_producto_contenido+1)
              }
              this.messages.push(the_message)
            }
          }
        }
      }

      var propuesta_inversion_elementos = this.prop_version.propuesta_inversion.elementos

      if(!propuesta_inversion_elementos || !propuesta_inversion_elementos.length) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario ingresar la propuesta económica'
        }
        this.messages.push(the_message)
      }else{
        //Comprobar que las propuestas tenga nombre precio frecuencia y cantidad
        for(var turn_elemento = 0; turn_elemento < propuesta_inversion_elementos.length; turn_elemento++){
          if(propuesta_inversion_elementos[turn_elemento].nombre == '' || this.$options.filters.formatFloat(propuesta_inversion_elementos[turn_elemento].precio) <= 0 || propuesta_inversion_elementos[turn_elemento].frecuencia == '' || this.$options.filters.formatFloat(propuesta_inversion_elementos[turn_elemento].cantidad) <= 0){
            const the_message = {
              type: 'fatal b-fail',
              content: 'Es necesario ingresar la información para el elemento '+(turn_elemento+1) + ' de la propuesta económica'
            }
            this.messages.push(the_message)
          }
        }
      }

      if(!this.prop_version.propuesta_inversion.titulo || this.prop_version.propuesta_inversion.titulo == '') {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario ingresar la propuesta de inversión'
        }
        this.messages.push(the_message)
      }

      if(!this.messages.length){
        this.isLoading = true
        var vm = this

        //Valores folio
        var next_quote = 1 //Folio cotizacion inicial
        var next_version = 1 //Numero de versiones en cotizacion

        //Obtener total de cotizaciones
        if(this.valor_total_cotizaciones[0].valor){
          next_quote = Number(this.valor_total_cotizaciones[0].valor) + 1
        }

        //Obtener total de versiones siempre y cuando no exista el total de versiones o no se trate de clonar cotizacion o version
        if((this.prop_cotizacion.total_versiones > 0) && type !== 'clone-quote'){
          next_version = Number(this.prop_cotizacion.total_versiones) + 1
        }

        var objeto_cliente = {
          id: vm.prop_version.id_cliente.id,
          color: vm.prop_version.id_cliente.color,
          empresa: vm.prop_version.id_cliente.empresa,
          contacto: vm.prop_version.id_cliente.contacto,
          nombre: vm.prop_version.id_cliente.nombre,
        }
        var total_servicios = []
        var the_content_product = []

        //Recorrer contenido productos cotizacion
        if(vm.prop_version.contenido){
          for(var turn_producto_version = 0; turn_producto_version < this.prop_version.contenido.length; turn_producto_version++){
            //Revisar que no sea un salto
            if(!vm.prop_version.contenido[turn_producto_version].salto || vm.prop_version.contenido[turn_producto_version].salto != true){
              //Referencia al servicio
              var referencia_servicio = {
                id: vm.prop_version.contenido[turn_producto_version].id_servicio.id,
                abreviacion: vm.prop_version.contenido[turn_producto_version].id_servicio.abreviacion,
                color: vm.prop_version.contenido[turn_producto_version].id_servicio.color,
                descripcion: vm.prop_version.contenido[turn_producto_version].id_servicio.descripcion,
                nombre: vm.prop_version.contenido[turn_producto_version].id_servicio.nombre,
              }
              //Asignar contenido
              the_content_product.push({
                anotaciones: vm.prop_version.contenido[turn_producto_version].anotaciones,
                contenido: vm.prop_version.contenido[turn_producto_version].contenido,
                id_servicio: referencia_servicio,
                //multiplicador: vm.prop_version.contenido[turn_producto_version].multiplicador,
                nombre: vm.prop_version.contenido[turn_producto_version].nombre
              })
              if(vm.prop_version.contenido[turn_producto_version].id_servicio){
                //Por cada producto asignar el servicio al arreglo para los servicios de la cotizacion si no esta repetido
                if(!total_servicios.find(o => o.id === vm.prop_version.contenido[turn_producto_version].id_servicio.id)){
                  total_servicios.push(referencia_servicio)
                }
              }
            }else{
              //Asignar contenido al salto
              the_content_product.push({
                anotaciones: vm.prop_version.contenido[turn_producto_version].anotaciones,
                contenido: vm.prop_version.contenido[turn_producto_version].contenido,
                id_servicio: {},
                salto: true,
                //multiplicador: vm.prop_version.contenido[turn_producto_version].multiplicador,
                nombre: vm.prop_version.contenido[turn_producto_version].nombre
              })
            }
          }
        }

        var data_quote_add = {
          color: vm.prop_version.color,
          fecha_creacion: new Date(),
          fecha_modificacion: new Date(),
          folio: next_quote,
          nombre: vm.prop_version.nombre,
          id_cliente: objeto_cliente,
          servicios: total_servicios,
          usuario_creador: vm.usuario_login.nombre,
          usuario_editor: vm.usuario_login.nombre,
        }

        var data_quote_update = {
          color: vm.prop_version.color,
          fecha_modificacion: new Date(),
          nombre: vm.prop_version.nombre,
          id_cliente: objeto_cliente,
          servicios: total_servicios,
          usuario_editor: vm.usuario_login.nombre,
        }

        var data_version_add = {
          color: vm.prop_version.color,
          contenido: the_content_product,
          fecha: new Date(vm.prop_version.fecha),
          fecha_creacion: new Date(),
          fecha_modificacion: new Date(),
          folio: next_version,
          id_cliente: objeto_cliente,
          nombre: vm.prop_version.nombre,
          propuesta_inversion: vm.prop_version.propuesta_inversion,
          usuario_creador: vm.usuario_login.nombre,
          usuario_editor: vm.usuario_login.nombre,
        }

        var data_version_update = {
          color: vm.prop_version.color,
          contenido: the_content_product,
          fecha: new Date(vm.prop_version.fecha),
          fecha_modificacion: new Date(),
          id_cliente: objeto_cliente,
          nombre: vm.prop_version.nombre,
          propuesta_inversion: vm.prop_version.propuesta_inversion,
          usuario_editor: vm.usuario_login.nombre,
        }

        if(!this.prop_cotizacion.id && type === 'form'){
          //Crear nueva cotizacion
          console.log('Crear nueva cotizacion');
          db.collection('cotizaciones').add(data_quote_add)
          .then(function(quote) {
            //Cotizacion creada con exito actualizar total de cotizaciones
            vm.update_total_quotes(next_quote);
            //Cotizacion creada con exito crear version
            db.collection('cotizaciones').doc(quote.id).collection('versiones').add(data_version_add)
            .then(function(doc) {
              //Version creada con exito actualizar total de versiones en actualizacion
              vm.update_total_versions(quote.id, next_version);
              //Version creada con exito
              vm.isLoading = false
              vm.$emit('actionChange', false)
              router.push('/cotizacion/'+quote.id, () => {})
            })
            .catch(function(error) {
              //Error al crear
              vm.isLoading = false
              vm.messages.push({type: 'fatal b-fail', content: error.message})
            })
          })
          .catch(function(error) {
            //Error al crear
            vm.isLoading = false
            vm.messages.push({type: 'fatal b-fail', content: error.message})
          })
        }else{
          if(type === 'form'){
            //Actualizar Version
            console.log('Actualizar Version');
            //Verificar que exista el id de la cotizacion
            db.collection('cotizaciones').doc(vm.prop_cotizacion.id).update(data_quote_update)
            .then(function(quote) {
              //Cotizacion actualizada con exito editar version
              db.collection('cotizaciones').doc(vm.prop_cotizacion.id).collection('versiones').doc(vm.prop_version.id).update(data_version_update)
              .then(function(doc) {
                //Version editada con exito
                vm.isLoading = false
                vm.$emit('actionChange', false)
                router.push('/cotizacion/'+vm.prop_cotizacion.id+'/'+vm.prop_version.id, () => {})
              })
              .catch(function(error) {
                //Error al crear
                vm.isLoading = false
                vm.messages.push({type: 'fatal b-fail', content: error.message})
              })
            })
            .catch(function(error) {
              //Error al crear
              vm.isLoading = false
              vm.messages.push({type: 'fatal b-fail', content: error.message})
            })
          }else if(type === 'add-version'){
            //Crear version
            console.log('Crear version');
            db.collection('cotizaciones').doc(vm.prop_cotizacion.id).update(data_quote_update)
            .then(function(quote) {
              //Cotizacion editada con exito crear version
              db.collection('cotizaciones').doc(vm.prop_cotizacion.id).collection('versiones').add(data_version_add)
              .then(function(doc) {
                //Version creada con exito actualizar total de versiones en actualizacion
                vm.update_total_versions(vm.prop_cotizacion.id, next_version);
                //Version creada con exito
                vm.isLoading = false
                vm.$emit('actionChange', false)
                router.push('/cotizacion/'+vm.prop_cotizacion.id, () => {})
              })
              .catch(function(error) {
                //Error al crear
                vm.isLoading = false
                vm.messages.push({type: 'fatal b-fail', content: error.message})
              })
            })
            .catch(function(error) {
              //Error al crear
              vm.isLoading = false
              vm.messages.push({type: 'fatal b-fail', content: error.message})
            })
          }else if(type === 'clone-version'){
            //Guardar como nueva version
            console.log('Guardar como nueva version');
            const answer = window.confirm('¿Estás Seguro? Esto creará una nueva versión descartando los cambios no guardados en la versión actual.')
            if(answer){
              db.collection('cotizaciones').doc(vm.prop_cotizacion.id).update(data_quote_update)
              .then(function(quote) {
                //Cotizacion editada con exito crear version
                db.collection('cotizaciones').doc(vm.prop_cotizacion.id).collection('versiones').add(data_version_add)
                .then(function(doc) {
                  //Version creada con exito actualizar total de versiones en actualizacion
                  vm.update_total_versions(vm.prop_cotizacion.id, next_version);
                  //Version creada con exito
                  vm.isLoading = false
                  vm.$emit('actionChange', false)
                  router.push('/cotizacion/'+vm.prop_cotizacion.id, () => {})
                })
                .catch(function(error) {
                  //Error al crear
                  vm.isLoading = false
                  vm.messages.push({type: 'fatal b-fail', content: error.message})
                })
              })
              .catch(function(error) {
                //Error al crear
                vm.isLoading = false
                vm.messages.push({type: 'fatal b-fail', content: error.message})
              })
            }else{
              //Cancelar guardado
              vm.isLoading = false
            }
          }else if(type === 'clone-quote'){
            //Guardar como nueva cotizacion
            console.log('Guardar como nueva cotizacion');
            const answer = window.confirm('¿Estás Seguro? Esto creará una nueva cotización descartando los cambios no guardados en la versión actual.')
            if(answer){
              db.collection('cotizaciones').add(data_quote_add)
              .then(function(quote) {
                //Cotizacion creada con exito actualizar total de cotizaciones
                vm.update_total_quotes(next_quote);
                //Cotizacion creada con exito crear version
                db.collection('cotizaciones').doc(quote.id).collection('versiones').add(data_version_add)
                .then(function(doc) {
                  //Version creada con exito actualizar total de versiones en actualizacion
                  vm.update_total_versions(quote.id, next_version);
                  //Version creada con exito
                  vm.isLoading = false
                  vm.$emit('actionChange', false)
                  router.push('/cotizacion/'+quote.id, () => {})
                })
                .catch(function(error) {
                  //Error al crear
                  vm.isLoading = false
                  vm.messages.push({type: 'fatal b-fail', content: error.message})
                })
              })
              .catch(function(error) {
                //Error al crear
                vm.isLoading = false
                vm.messages.push({type: 'fatal b-fail', content: error.message})
              })
            }else{
              //Cancelar guardado
              vm.isLoading = false
            }
          }
        }
      }

    },
    update_total_quotes (value){
      //Asignar valor a total_cotizaciones
      db.collection('valores').where('relacion', '==', 'total_cotizaciones').limit(1)
      .get()
      .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
              if(doc.exists){
                db.collection('valores').doc(doc.id).update({valor: value})
              }
          })
      })
    },
    update_total_versions (id, value){
      //Actualizar el total de actualizaciones
      db.collection('cotizaciones').doc(id).update({total_versiones: value})
    }
  },
}
</script>
<style src='vue-swatches/dist/vue-swatches.min.css'></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  @import url('../../node_modules/vue-datetime/dist/vue-datetime.css')
</style>